import { FiuUtrFiling } from '@/features/fiu-utr/fiu-utr-filing';

const FiuUtrPage = () => <FiuUtrFiling />;
FiuUtrPage.displayName = 'FiuUtrPage';

export default FiuUtrPage;
